import * as bootstrap from "bootstrap";
const element = document.querySelector("#modalAccountCreated");
if (element && location.search === '?created=true') {
    const myModal = new bootstrap.Modal(element, {
    })
    myModal.show();
}

export default undefined;
